import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsCISReverseVAT from './SettingsCISReverseVAT';

function CISReverseVATPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="CIS & Reverse VAT"
        subtitle="CIS deductions and reverse charge VAT"
        backTo="/settings/finance-setup"
        backLabel="Finance Setup"
        sticky
      />
      <main className="max-w-7xl mx-auto px-6 py-8">
        <SettingsCISReverseVAT />
      </main>
    </div>
  );
}

export default CISReverseVATPage;
